// removed by extract-text-webpack-plugin
module.exports = {"header":"_1qJv7kYOr8uUICY8tXdP70","facebook":"_31KCeu9whDO5salDkq_lgE","logo":"_3udu9eDCKBUl8nMVEyQRDp","footer":"_3g-8mJyj7TwjZtuSKtWI2j"};


//////////////////
// WEBPACK FOOTER
// ./_template.module.scss
// module id = 390
// module chunks = 0